import { setLoadingStatus, setUploadStatus } from "../slices/spinnerSlice";

export const setUploadSpinnerStatus = (status) => (dispatch) => {
  dispatch(setUploadStatus(status));
};

export const setLoadSpinnerStatus = (status) => (dispatch) => {
  dispatch(setLoadingStatus(status));
};
